import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';

import { AUTH_MANAGER } from '@asset-solutions/customer-portal/auth/data-access';
import { NotificationService } from '@asset-solutions/shared/utilities';
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';

import { NewPasswordComponent } from '../new-password/new-password.component';

@Component({
  selector: 'auth-change-password',
  imports: [FormsModule, MatInputModule, MatButton, NewPasswordComponent],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangePasswordComponent {
  private readonly notificationService = inject(NotificationService);
  private readonly router = inject(Router);
  private readonly authManager = inject(AUTH_MANAGER);

  protected formData = { currentPassword: '', newPassword: '' };

  protected submitPasswordChange(): void {
    const user = this.authManager.currentUser();
    if (user && user.email) {
      const credential = EmailAuthProvider.credential(user.email, this.formData.currentPassword);

      reauthenticateWithCredential(user, credential)
        .then((userCredential) => updatePassword(userCredential.user, this.formData.newPassword))
        .then(() => {
          this.notificationService.success('Your password has been changed');
          this.router.navigate(['/']);
        })
        .catch(() => {
          this.notificationService.error("There was an issue, your password couldn't be changed");
        });
    }
  }
}
